// components/TZ/Tz.jsx
import React, { useEffect, useMemo, useState } from 'react';
import { Tabs } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

import NameResults from './nameRes/NameResults.jsx';
import DescriptionSearchResults from './descriptionRes/DescriptionResults.jsx';
import AdressResults from './adressRes/AdressResults.jsx';
import PatentOblResults from './patentOblRes/PatentOblResults.jsx';
import KonstruktorResults from './konstruktorRes/KonstruktorResults';
import ImageResults from './imageRes/ImageResults.jsx';
import GlobalSearchTab from './globalSearchRes/GlobalSearchTab.jsx';

const TAB_KEYS = ['1', '2', '3', '4', '5', '6', '7'];

const Tz = () => {
  const [activeKey, setActiveKey] = useState('1');
  const [compactNav, setCompactNav] = useState(
    () => typeof window !== 'undefined' && window.matchMedia('(max-width: 768px)').matches
  );

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 768px)');
    const apply = () => setCompactNav(mq.matches);
    apply();
    mq.addEventListener('change', apply);
    return () => mq.removeEventListener('change', apply);
  }, []);

  useEffect(() => {
    if (TAB_KEYS.indexOf(activeKey) === -1) {
      setActiveKey('1');
    }
  }, [activeKey]);

  const items = useMemo(
    () => [
      {
        key: '1',
        label: 'По названию',
        children: <NameResults />
      },
      {
        key: '2',
        label: 'По содержанию',
        children: <DescriptionSearchResults />
      },
      {
        key: '3',
        label: 'По адресу',
        children: <AdressResults />
      },
      {
        key: '4',
        label: 'По правообладателю',
        children: <PatentOblResults />
      },
      {
        key: '5',
        label: 'По изображению',
        children: <ImageResults />
      },
      {
        key: '6',
        label: 'Конструктор',
        children: <KonstruktorResults />
      },
      {
        key: '7',
        label: 'Глобальный поиск',
        children: <GlobalSearchTab />
      }
    ],
    []
  );

  const idx = TAB_KEYS.indexOf(activeKey);
  const safeIdx = idx === -1 ? 0 : idx;
  const canPrev = safeIdx > 0;
  const canNext = safeIdx < TAB_KEYS.length - 1;

  const tabBarExtraContent = compactNav
    ? {
        left: canPrev ? (
          <button
            type="button"
            className="tz-tab-nav-arrow tz-tab-nav-arrow--prev"
            aria-label="Предыдущий режим поиска"
            onClick={() => setActiveKey(TAB_KEYS[safeIdx - 1])}
          >
            <LeftOutlined />
          </button>
        ) : null,
        right: canNext ? (
          <button
            type="button"
            className="tz-tab-nav-arrow tz-tab-nav-arrow--next"
            aria-label="Следующий режим поиска"
            onClick={() => setActiveKey(TAB_KEYS[safeIdx + 1])}
          >
            <RightOutlined />
          </button>
        ) : null
      }
    : undefined;

  return (
    <div className="tabs-container tz-search-tabs">
      <Tabs
        activeKey={activeKey}
        onChange={setActiveKey}
        className="custom-tabs"
        destroyInactiveTabPane={false}
        items={items}
        tabBarExtraContent={tabBarExtraContent}
      />
    </div>
  );
};

export default Tz;
